import _slicedToArray from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var isEvent = function isEvent(key) {
  return /^on[A-Z]/.test(key);
};
var getEventsFromProps = function getEventsFromProps(props) {
  return Object.keys(props).filter(isEvent).map(getEventFromKey);
};
var getEventFromKey = function getEventFromKey(key) {
  return key.substr(2).toLowerCase();
};
export var unsub = function unsub(component) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  (component.unsubs || []
  // events not supplied, or event is in events list
  ).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      event = _ref2[0];
    return !events || events.includes(event);
  }).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      unsub = _ref4[1];
    return unsub();
  });
};
export var sub = function sub(component, props) {
  // unsub existing subscriptions
  unsub(component, getEventsFromProps(props));

  // subscribe
  component.unsubs = Object.keys(props).filter(isEvent).map(function (key) {
    var type = getEventFromKey(key);
    return [type, component.editor.on(type, props[key])];
  });
};